import { createGenericQuery, getGenericQueryKey } from 'js/react_query_helpers/helpers';
export const makeRivieraDataQueryPackage = ({ fileTypeSpecificQueryFn, fieldName, }) => {
    return createGenericQuery({
        queryRouteFilter: ['custom', 'riviera'],
        getQueryKey: getGenericQueryKey('custom', `riviera_${fieldName}`, (args) => {
            var _a, _b, _c;
            return (((_a = args.previewKey) === null || _a === void 0 ? void 0 : _a.serialized) +
                JSON.stringify((_b = args.previewMetadata) === null || _b === void 0 ? void 0 : _b.preview_url) +
                JSON.stringify((_c = args.previewMetadata) === null || _c === void 0 ? void 0 : _c.content) +
                JSON.stringify({ ...args, previewKey: undefined, previewMetadata: undefined }));
        }),
        queryFn: (args) => async () => {
            const { previewKey } = args.apiArg;
            if (!previewKey) {
                throw new Error('No preview key provided to Riviera query.');
            }
            try {
                const result = await fileTypeSpecificQueryFn(args.apiArg);
                return { apiData: result, pkgData: null };
            }
            catch (err) {
                throw err;
            }
        },
    });
};
//# sourceMappingURL=riviera_base.preenvesnextjs.map
